/* eslint-disable react/jsx-max-depth */
/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */
import {
	subTabSX,
	tabSX,
	textDescriptionDrawerSX,
	headerTitlesRopaSX,
} from '@/components/blocks/ProductDetails/styles/guiaTallas';
import {
	Box,
	Button,
	ButtonGroup,
	Divider,
	Stack,
	styled,
	Tab,
	Table,
	TableBody,
	TableCell,
	tableCellClasses,
	TableContainer,
	TableHead,
	TableRow,
	Tabs,
	Typography,
} from '@mui/material';
import React, { useState } from 'react';
import { FC } from 'react';

interface TabPanelProps {
	children?: React.ReactNode;
	index: number;
	value: number;
}
// eslint-disable-next-line func-style, prefer-arrow/prefer-arrow-functions
function CustomTabPanel(props: TabPanelProps) {
	const { children, value, index, ...other } = props;

	return (
		<Stack
			role="tabpanel"
			hidden={value !== index}
			id={`simple-tabpanel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
			{...other}
		>
			{value === index ? <Box sx={{ py: 1 }}>{children}</Box> : null}
		</Stack>
	);
}

// eslint-disable-next-line func-style, prefer-arrow/prefer-arrow-functions
function createDataMenCalzado(mx: string, us: string, eur: string, uk: string) {
	return { mx, us, eur, uk };
}

// eslint-disable-next-line func-style, prefer-arrow/prefer-arrow-functions
function createWomenData(mx: string, us: string, eur: string, uk: string) {
	return { mx, us, eur, uk };
}

// eslint-disable-next-line func-style, prefer-arrow/prefer-arrow-functions
function createKidsData(mx: string, us: string, eur: string, uk: string) {
	return { mx, us, eur, uk };
}

// eslint-disable-next-line func-style, prefer-arrow/prefer-arrow-functions
function createGorrasData(gorra: string, cm: string, pul: string) {
	return { gorra, cm, pul };
}

// eslint-disable-next-line func-style, prefer-arrow/prefer-arrow-functions
function createRopaMujerData(talla: string, pecho: string, cintura: string, cadera: string) {
	return { talla, pecho, cintura, cadera };
}

// eslint-disable-next-line func-style, prefer-arrow/prefer-arrow-functions
function createRopaHombreData(talla: string, pecho: string, cintura: string, cadera: string) {
	return { talla, pecho, cintura, cadera };
}

// eslint-disable-next-line func-style, prefer-arrow/prefer-arrow-functions
function createRopaNinoData(talla: string, pecho: string, cintura: string, cadera: string) {
	return { talla, pecho, cintura, cadera };
}

const ropaNinoCmRows = [
	createRopaNinoData('XCH', '25 cm', '25 cm', '25 cm'),
	createRopaNinoData('CH', '25.5 cm', '25.5 cm', '25.5 cm'),
	createRopaNinoData('M', '26 cm', '26 cm', '26 cm'),
	createRopaNinoData('G', '26.5 cm', '26.5 cm', '26.5 cm'),
	createRopaNinoData('XG', '27 cm', '27 cm', '27 cm'),
];

const ropaNinoInchesRows = [
	createRopaNinoData('XCH', '9.84 in', '9.84 in', '9.84 in'),
	createRopaNinoData('CH', '10.04 in', '10.04 in', '10.04 in'),
	createRopaNinoData('M', '10.24 in', '10.24 in', '10.24 in'),
	createRopaNinoData('G', '10.43 in', '10.43 in', '10.43 in'),
	createRopaNinoData('XG', '10.63 in', '10.63 in', '10.63 in'),
];

const ropaHombreCmRows = [
	createRopaHombreData('XCH', '25 cm', '25 cm', '25 cm'),
	createRopaHombreData('CH', '25.5 cm', '25.5 cm', '25.5 cm'),
	createRopaHombreData('M', '26 cm', '26 cm', '26 cm'),
	createRopaHombreData('G', '26.5 cm', '26.5 cm', '26.5 cm'),
	createRopaHombreData('XG', '27 cm', '27 cm', '27 cm'),
];

const ropaHombreInchesRows = [
	createRopaHombreData('XCH', '9.84 in', '9.84 in', '9.84 in'),
	createRopaHombreData('CH', '10.04 in', '10.04 in', '10.04 in'),
	createRopaHombreData('M', '10.24 in', '10.24 in', '10.24 in'),
	createRopaHombreData('G', '10.43 in', '10.43 in', '10.43 in'),
	createRopaHombreData('XG', '10.63 in', '10.63 in', '10.63 in'),
];

const ropaMujerCmRows = [
	createRopaMujerData('XCH', '25 cm', '25 cm', '25 cm'),
	createRopaMujerData('CH', '25.5 cm', '25.5 cm', '25.5 cm'),
	createRopaMujerData('M', '26 cm', '26 cm', '26 cm'),
	createRopaMujerData('G', '26.5 cm', '26.5 cm', '26.5 cm'),
	createRopaMujerData('XG', '27 cm', '27 cm', '27 cm'),
];

const ropaMujerInchesRows = [
	createRopaMujerData('XCH', '9.84 in', '9.84 in', '9.84 in'),
	createRopaMujerData('CH', '10.04 in', '10.04 in', '10.04 in'),
	createRopaMujerData('M', '10.24 in', '10.24 in', '10.24 in'),
	createRopaMujerData('G', '10.43 in', '10.43 in', '10.43 in'),
	createRopaMujerData('XG', '10.63 in', '10.63 in', '10.63 in'),
];

const gorrasRows = [
	createGorrasData('6 6/8', '54.9', '21 5/8'),
	createGorrasData('7', '55.8', '22'),
	createGorrasData('7 1/8', '56.8', '22 3/8'),
	createGorrasData('7 1/4', '57.7', '22 3/4'),
	createGorrasData('7 3/8', '58.7', '23 1/8'),
	createGorrasData('7 1/2', '59.6', '23 1/2'),
	createGorrasData('7 5/8', '60.6', '23 7/8'),
	createGorrasData('7 3/4', '61.5', '24 1/4'),
	createGorrasData('7 7/8', '63', '24 5/8'),
	createGorrasData('9', '64', '25'),
];

const menRows = [
	createDataMenCalzado('25', '7', '40', '6.5'),
	createDataMenCalzado('25.5', '7.5', '40.5', '7'),
	createDataMenCalzado('26', '8', '41', '7.5'),
	createDataMenCalzado('26.5', '8.5', '42', '8'),
	createDataMenCalzado('27', '9', '42.5', '8.5'),
	createDataMenCalzado('27.5', '9.5', '43', '9'),
	createDataMenCalzado('28', '10', '44', '9.5'),
	createDataMenCalzado('28.5', '10.5', '44.5', '10'),
	createDataMenCalzado('29', '11', '45', '10.5'),
	createDataMenCalzado('29.5', '11.5', '45.5', '11'),
	createDataMenCalzado('30', '12', '46', '11.5'),
	createDataMenCalzado('30.5', '12.5', '46.5', '12'),
	createDataMenCalzado('31', '13', '47', '12.5'),
	createDataMenCalzado('31.5', '13.5', '47.5', '13'),
	createDataMenCalzado('32', '14', '48', '13.5'),
	createDataMenCalzado('32.5', '14.5', '48.5', '14'),
	createDataMenCalzado('33', '15', '49', '14.5'),
];

const womenRows = [
	createWomenData('22', '5', '35', '2.5'),
	createWomenData('22.5', '5.5', '35.5', '3'),
	createWomenData('23', '6', '36', '3.5'),
	createWomenData('23.5', '6.5', '36.5', '4'),
	createWomenData('24', '7', '37', '4.5'),
	createWomenData('24.5', '7.5', '37.5', '5'),
	createWomenData('25', '8', '38', '5.5'),
	createWomenData('25.5', '8.5', '38.5', '6'),
	createWomenData('26', '9', '39', '6.5'),
	createWomenData('26.5', '9.5', '40', '7'),
	createWomenData('27', '10', '40.5', '7.5'),
	createWomenData('27.5', '10.5', '41', '8'),
	createWomenData('28', '11', '42', '8.5'),
	createWomenData('28.5', '11.5', '42.5', '9'),
	createWomenData('29', '12', '43', '9.5'),
	createWomenData('29.5', '12.5', '43.5', '10'),
	createWomenData('30', '13', '44', '10.5'),
];

const kidsRows = [
	createKidsData('15', '8C', '24', '7.5'),
	createKidsData('15.5', '8.5C', '24.5', '8'),
	createKidsData('16', '9C', '25', '8.5'),
	createKidsData('16.5', '9.5C', '25.5', '9'),
	createKidsData('17', '10C', '26', '9.5'),
	createKidsData('17.5', '10.5C', '26.5', '10'),
	createKidsData('18', '11C', '27', '10.5'),
	createKidsData('18.5', '11.5C', '27.5', '11'),
	createKidsData('19', '12C', '28', '11.5'),
	createKidsData('19.5', '12.5C', '28.5', '12'),
	createKidsData('20', '13C', '29', '12.5'),
	createKidsData('20.5', '13.5C', '30', '13'),
	createKidsData('21', '1Y', '31', '13.5'),
	createKidsData('21.5', '1.5Y', '31.5', '1'),
	createKidsData('22', '2Y', '32', '1.5'),
	createKidsData('22.5', '2.5Y', '32.5', '2'),
	createKidsData('23', '3Y', '33', '2.5'),
	createKidsData('23.5', '3.5Y', '33.5', '3'),
	createKidsData('24', '4Y', '34', '3.5'),
	createKidsData('24.5', '4.5Y', '34.5', '4'),
	createKidsData('25', '5Y', '35', '4.5'),
];

const StyledTableCell = styled(TableCell)(() => ({
	border: 'none',
	[`&.${tableCellClasses.head}`]: {
		backgroundColor: 'red',
	},
	[`&.${tableCellClasses.body}`]: {
		fontSize: 'var(--font-size-body)',
		color: '#2C2C2C',
	},
}));

const StyledTableRow = styled(TableRow)(() => ({
	'&:nth-of-type(odd)': {
		backgroundColor: '#F8F8F8',
		border: 0,
	},
	// hide last border
	'&:last-child td, &:last-child th': {
		border: 0,
	},
}));

// eslint-disable-next-line complexity
export const GuiaTallasDrawer: FC = () => {
	const [value, setValue] = React.useState(0);
	const [valueHombres, setValueHombres] = React.useState(0);

	const [activeCmMujer, setCmMujer] = useState<boolean>(true);
	const [activeCmHombre, setCmHombre] = useState<boolean>(true);
	const [activeCmNino, setCmNino] = useState<boolean>(true);

	const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
		setValue(newValue);
	};

	const handleChangeHombres = (_event: React.SyntheticEvent, newValue: number) => {
		setValueHombres(newValue);
	};

	const handleSetCm = (value: boolean) => {
		setCmMujer(value);
		setCmHombre(value);
		setCmNino(value);
	};

	const buttons = [
		<Button
			onClick={() => handleSetCm(true)}
			sx={{
				backgroundColor: !activeCmMujer ? '#FFFFFF' : '#F8F7F7',
				border: '1px solid #D5D5D5',
				color: !activeCmMujer ? '#767676' : '#000000',
				fontSize: 'var(--font-size-body)',
				fontWeight: 'normal',
				borderRadius: 0,
				padding: '6px',
				'&:hover': {
					backgroundColor: '#F8F7F7',
					color: '#000000',
					border: '1px solid #D5D5D5',
				},
			}}
			key="CM"
		>
			{'CM'}
		</Button>,
		<Button
			onClick={() => handleSetCm(false)}
			sx={{
				backgroundColor: activeCmMujer ? '#FFFFFF' : '#F8F7F7',
				border: '1px solid #D5D5D5',
				color: activeCmMujer ? '#767676' : '#000000',
				fontSize: 'var(--font-size-body)',
				fontWeight: 'normal',
				borderRadius: 0,
				padding: '6px',
				'&:hover': {
					backgroundColor: '#F8F7F7',
					color: '#000000',
					border: '1px solid #D5D5D5',
				},
			}}
			key="IN"
		>
			{'IN'}
		</Button>,
	];

	return (
		<Box>
			<Stack
				sx={{
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'left',
				}}
				spacing={2}
			>
				<Stack sx={{ marginTop: '20px' }}>
					<Typography sx={textDescriptionDrawerSX}>
						{
							'Las tallas del calzado estan expresados en la medida local (MX), recomendamos tenerlo en cuenta al momento de realizar tu compra o al revisarlo en la guia de tallas'
						}
					</Typography>
				</Stack>
				<Stack>
					<Box sx={{ width: '100%' }}>
						<Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
							<Tabs
								value={value}
								onChange={handleChange}
								aria-label="basic tabs example"
								sx={{ backgroundColor: '#F5F5F5' }}
							>
								<Tab label="HOMBRE" sx={tabSX} />
								<Tab label="MUJER" sx={tabSX} />
								<Tab label="NIÑOS" sx={tabSX} />
							</Tabs>
						</Box>
						<CustomTabPanel value={value} index={0}>
							<Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
								<Tabs
									value={valueHombres}
									onChange={handleChangeHombres}
									aria-label="basic tabs hombre"
									sx={{ backgroundColor: 'transparent' }}
								>
									<Tab label="Calzado" sx={subTabSX} />
									<Tab label="Ropa" sx={subTabSX} />
									<Tab label="Gorras" sx={subTabSX} />
								</Tabs>
							</Box>
							<CustomTabPanel value={valueHombres} index={0}>
								<TableContainer sx={{ maxHeight: '400px' }}>
									<Table sx={{ minWidth: '0px' }} stickyHeader aria-label="sticky table">
										<TableHead>
											<TableRow>
												<TableCell>{'MX'}</TableCell>
												<TableCell>{'US'}</TableCell>
												<TableCell>{'EUR'}</TableCell>
												<TableCell>{'UK'}</TableCell>
											</TableRow>
										</TableHead>
										<TableBody>
											{menRows.map((row) => (
												<StyledTableRow key={row.mx}>
													<StyledTableCell>{row.mx}</StyledTableCell>
													<StyledTableCell>{row.us}</StyledTableCell>
													<StyledTableCell>{row.eur}</StyledTableCell>
													<StyledTableCell>{row.uk}</StyledTableCell>
												</StyledTableRow>
											))}
										</TableBody>
									</Table>
								</TableContainer>
							</CustomTabPanel>
							<CustomTabPanel value={valueHombres} index={1}>
								<Stack
									mt={'0px'}
									mb={'8px'}
									direction={'row'}
									alignItems={'flex-end'}
									justifyContent={'space-between'}
								>
									<Stack>
										<Typography
											sx={{
												fontSize: 'var(--font-size-sm)',
												fontWeight: 'bold',
												color: '#2C2C2C',
											}}
										>
											{'Parte Superior'}
										</Typography>
									</Stack>
									<Stack>
										<ButtonGroup
											sx={{ backgroundColor: '#FFF' }}
											size="small"
											aria-label="Small button group"
										>
											{buttons}
										</ButtonGroup>
									</Stack>
								</Stack>
								<Divider></Divider>
								<TableContainer>
									<Table sx={{ minWidth: '0px' }}>
										<TableHead>
											<TableRow sx={{ pt: '0px' }}>
												<TableCell sx={headerTitlesRopaSX}>{'Talla'}</TableCell>
												<TableCell sx={headerTitlesRopaSX}>{'Pecho'}</TableCell>
												<TableCell sx={headerTitlesRopaSX}>{'Cintura'}</TableCell>
												<TableCell sx={headerTitlesRopaSX}>{'Cadera'}</TableCell>
											</TableRow>
										</TableHead>

										{activeCmHombre ? (
											<TableBody>
												{ropaHombreCmRows.map((row) => (
													<StyledTableRow key={row.talla}>
														<StyledTableCell>{row.talla}</StyledTableCell>
														<StyledTableCell>{row.pecho}</StyledTableCell>
														<StyledTableCell>{row.cintura}</StyledTableCell>
														<StyledTableCell>{row.cadera}</StyledTableCell>
													</StyledTableRow>
												))}
											</TableBody>
										) : (
											<TableBody>
												{ropaHombreInchesRows.map((row) => (
													<StyledTableRow key={row.talla}>
														<StyledTableCell>{row.talla}</StyledTableCell>
														<StyledTableCell>{row.pecho}</StyledTableCell>
														<StyledTableCell>{row.cintura}</StyledTableCell>
														<StyledTableCell>{row.cadera}</StyledTableCell>
													</StyledTableRow>
												))}
											</TableBody>
										)}
									</Table>
								</TableContainer>
								<Stack mt={'27px'} mb={'8px'}>
									<Stack>
										<Typography
											sx={{
												fontSize: 'var(--font-size-sm)',
												fontWeight: 'bold',
												color: '#2C2C2C',
											}}
										>
											{'Pans y leggins'}
										</Typography>
									</Stack>
								</Stack>
								<Divider></Divider>
								<TableContainer>
									<Table sx={{ minWidth: '0px' }}>
										<TableHead>
											<TableRow sx={{ pt: '0px' }}>
												<TableCell sx={headerTitlesRopaSX}>{'Talla'}</TableCell>
												<TableCell sx={headerTitlesRopaSX}>{'Pecho'}</TableCell>
												<TableCell sx={headerTitlesRopaSX}>{'Cintura'}</TableCell>
												<TableCell sx={headerTitlesRopaSX}>{'Cadera'}</TableCell>
											</TableRow>
										</TableHead>
										{activeCmHombre ? (
											<TableBody>
												{ropaHombreCmRows.map((row) => (
													<StyledTableRow key={row.talla}>
														<StyledTableCell>{row.talla}</StyledTableCell>
														<StyledTableCell>{row.pecho}</StyledTableCell>
														<StyledTableCell>{row.cintura}</StyledTableCell>
														<StyledTableCell>{row.cadera}</StyledTableCell>
													</StyledTableRow>
												))}
											</TableBody>
										) : (
											<TableBody>
												{ropaHombreInchesRows.map((row) => (
													<StyledTableRow key={row.talla}>
														<StyledTableCell>{row.talla}</StyledTableCell>
														<StyledTableCell>{row.pecho}</StyledTableCell>
														<StyledTableCell>{row.cintura}</StyledTableCell>
														<StyledTableCell>{row.cadera}</StyledTableCell>
													</StyledTableRow>
												))}
											</TableBody>
										)}
									</Table>
								</TableContainer>
							</CustomTabPanel>
							<CustomTabPanel value={valueHombres} index={2}>
								<TableContainer sx={{ maxHeight: '400px' }}>
									<Table sx={{ minWidth: '0px' }} stickyHeader aria-label="sticky table">
										<TableHead>
											<TableRow>
												<TableCell>{'GORRA'}</TableCell>
												<TableCell>{'CENTIMETROS'}</TableCell>
												<TableCell>{'PULGADAS'}</TableCell>
											</TableRow>
										</TableHead>
										<TableBody>
											{gorrasRows.map((row) => (
												<StyledTableRow key={row.gorra}>
													<StyledTableCell>{row.gorra}</StyledTableCell>
													<StyledTableCell>{row.cm}</StyledTableCell>
													<StyledTableCell>{row.pul}</StyledTableCell>
												</StyledTableRow>
											))}
										</TableBody>
									</Table>
								</TableContainer>
							</CustomTabPanel>
						</CustomTabPanel>
						<CustomTabPanel value={value} index={1}>
							<Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
								<Tabs
									value={valueHombres}
									onChange={handleChangeHombres}
									aria-label="basic tabs example"
									sx={{ backgroundColor: 'transparent' }}
								>
									<Tab label="Calzado" sx={subTabSX} />
									<Tab label="Ropa" sx={subTabSX} />
									<Tab label="Gorras" sx={subTabSX} />
								</Tabs>
							</Box>
							<CustomTabPanel value={valueHombres} index={0}>
								<TableContainer sx={{ maxHeight: '400px' }}>
									<Table sx={{ minWidth: '0px' }} stickyHeader aria-label="sticky table">
										<TableHead>
											<TableRow>
												<TableCell>{'MX'}</TableCell>
												<TableCell>{'US'}</TableCell>
												<TableCell>{'EUR'}</TableCell>
												<TableCell>{'UK'}</TableCell>
											</TableRow>
										</TableHead>
										<TableBody>
											{womenRows.map((row) => (
												<StyledTableRow key={row.mx}>
													<StyledTableCell>{row.mx}</StyledTableCell>
													<StyledTableCell>{row.us}</StyledTableCell>
													<StyledTableCell>{row.eur}</StyledTableCell>
													<StyledTableCell>{row.uk}</StyledTableCell>
												</StyledTableRow>
											))}
										</TableBody>
									</Table>
								</TableContainer>
							</CustomTabPanel>
							<CustomTabPanel value={valueHombres} index={1}>
								<Stack
									mt={'0px'}
									mb={'8px'}
									direction={'row'}
									alignItems={'flex-end'}
									justifyContent={'space-between'}
								>
									<Stack>
										<Typography
											sx={{
												fontSize: 'var(--font-size-sm)',
												fontWeight: 'bold',
												color: '#2C2C2C',
											}}
										>
											{'Parte Superior'}
										</Typography>
									</Stack>
									<Stack>
										<ButtonGroup
											sx={{ backgroundColor: '#FFF' }}
											size="small"
											aria-label="Small button group"
										>
											{buttons}
										</ButtonGroup>
									</Stack>
								</Stack>
								<Divider></Divider>
								<TableContainer>
									<Table sx={{ minWidth: '0px' }}>
										<TableHead>
											<TableRow sx={{ pt: '0px' }}>
												<TableCell sx={headerTitlesRopaSX}>{'Talla'}</TableCell>
												<TableCell sx={headerTitlesRopaSX}>{'Pecho'}</TableCell>
												<TableCell sx={headerTitlesRopaSX}>{'Cintura'}</TableCell>
												<TableCell sx={headerTitlesRopaSX}>{'Cadera'}</TableCell>
											</TableRow>
										</TableHead>

										{activeCmMujer ? (
											<TableBody>
												{ropaMujerCmRows.map((row) => (
													<StyledTableRow key={row.talla}>
														<StyledTableCell>{row.talla}</StyledTableCell>
														<StyledTableCell>{row.pecho}</StyledTableCell>
														<StyledTableCell>{row.cintura}</StyledTableCell>
														<StyledTableCell>{row.cadera}</StyledTableCell>
													</StyledTableRow>
												))}
											</TableBody>
										) : (
											<TableBody>
												{ropaMujerInchesRows.map((row) => (
													<StyledTableRow key={row.talla}>
														<StyledTableCell>{row.talla}</StyledTableCell>
														<StyledTableCell>{row.pecho}</StyledTableCell>
														<StyledTableCell>{row.cintura}</StyledTableCell>
														<StyledTableCell>{row.cadera}</StyledTableCell>
													</StyledTableRow>
												))}
											</TableBody>
										)}
									</Table>
								</TableContainer>
								<Stack mt={'27px'} mb={'8px'}>
									<Stack>
										<Typography
											sx={{
												fontSize: 'var(--font-size-sm)',
												fontWeight: 'bold',
												color: '#2C2C2C',
											}}
										>
											{'Pans y leggins'}
										</Typography>
									</Stack>
								</Stack>
								<Divider></Divider>
								<TableContainer>
									<Table sx={{ minWidth: '0px' }}>
										<TableHead>
											<TableRow sx={{ pt: '0px' }}>
												<TableCell sx={headerTitlesRopaSX}>{'Talla'}</TableCell>
												<TableCell sx={headerTitlesRopaSX}>{'Pecho'}</TableCell>
												<TableCell sx={headerTitlesRopaSX}>{'Cintura'}</TableCell>
												<TableCell sx={headerTitlesRopaSX}>{'Cadera'}</TableCell>
											</TableRow>
										</TableHead>
										{activeCmMujer ? (
											<TableBody>
												{ropaMujerCmRows.map((row) => (
													<StyledTableRow key={row.talla}>
														<StyledTableCell>{row.talla}</StyledTableCell>
														<StyledTableCell>{row.pecho}</StyledTableCell>
														<StyledTableCell>{row.cintura}</StyledTableCell>
														<StyledTableCell>{row.cadera}</StyledTableCell>
													</StyledTableRow>
												))}
											</TableBody>
										) : (
											<TableBody>
												{ropaMujerInchesRows.map((row) => (
													<StyledTableRow key={row.talla}>
														<StyledTableCell>{row.talla}</StyledTableCell>
														<StyledTableCell>{row.pecho}</StyledTableCell>
														<StyledTableCell>{row.cintura}</StyledTableCell>
														<StyledTableCell>{row.cadera}</StyledTableCell>
													</StyledTableRow>
												))}
											</TableBody>
										)}
									</Table>
								</TableContainer>
							</CustomTabPanel>
							<CustomTabPanel value={valueHombres} index={2}>
								<TableContainer sx={{ maxHeight: '400px' }}>
									<Table sx={{ minWidth: '0px' }} stickyHeader aria-label="sticky table">
										<TableHead>
											<TableRow>
												<TableCell>{'GORRA'}</TableCell>
												<TableCell>{'CENTIMETROS'}</TableCell>
												<TableCell>{'PULGADAS'}</TableCell>
											</TableRow>
										</TableHead>
										<TableBody>
											{gorrasRows.map((row) => (
												<StyledTableRow key={row.gorra}>
													<StyledTableCell>{row.gorra}</StyledTableCell>
													<StyledTableCell>{row.cm}</StyledTableCell>
													<StyledTableCell>{row.pul}</StyledTableCell>
												</StyledTableRow>
											))}
										</TableBody>
									</Table>
								</TableContainer>
							</CustomTabPanel>
						</CustomTabPanel>
						<CustomTabPanel value={value} index={2}>
							<Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
								<Tabs
									value={valueHombres}
									onChange={handleChangeHombres}
									aria-label="basic tabs example"
									sx={{ backgroundColor: 'transparent' }}
								>
									<Tab label="Calzado" sx={subTabSX} />
									<Tab label="Ropa" sx={subTabSX} />
									<Tab label="Gorras" sx={subTabSX} />
								</Tabs>
							</Box>
							<CustomTabPanel value={valueHombres} index={0}>
								<TableContainer sx={{ maxHeight: '400px' }}>
									<Table sx={{ minWidth: '0px' }} stickyHeader aria-label="sticky table">
										<TableHead>
											<TableRow>
												<TableCell>{'MX'}</TableCell>
												<TableCell>{'US'}</TableCell>
												<TableCell>{'EUR'}</TableCell>
												<TableCell>{'UK'}</TableCell>
											</TableRow>
										</TableHead>
										<TableBody>
											{kidsRows.map((row) => (
												<StyledTableRow key={row.mx}>
													<StyledTableCell>{row.mx}</StyledTableCell>
													<StyledTableCell>{row.us}</StyledTableCell>
													<StyledTableCell>{row.eur}</StyledTableCell>
													<StyledTableCell>{row.uk}</StyledTableCell>
												</StyledTableRow>
											))}
										</TableBody>
									</Table>
								</TableContainer>
							</CustomTabPanel>
							<CustomTabPanel value={valueHombres} index={1}>
								<Stack
									mt={'0px'}
									mb={'8px'}
									direction={'row'}
									alignItems={'flex-end'}
									justifyContent={'space-between'}
								>
									<Stack>
										<Typography
											sx={{
												fontSize: 'var(--font-size-sm)',
												fontWeight: 'bold',
												color: '#2C2C2C',
											}}
										>
											{'Parte Superior'}
										</Typography>
									</Stack>
									<Stack>
										<ButtonGroup
											sx={{ backgroundColor: '#FFF' }}
											size="small"
											aria-label="Small button group"
										>
											{buttons}
										</ButtonGroup>
									</Stack>
								</Stack>
								<Divider></Divider>
								<TableContainer>
									<Table sx={{ minWidth: '0px' }}>
										<TableHead>
											<TableRow sx={{ pt: '0px' }}>
												<TableCell sx={headerTitlesRopaSX}>{'Talla'}</TableCell>
												<TableCell sx={headerTitlesRopaSX}>{'Pecho'}</TableCell>
												<TableCell sx={headerTitlesRopaSX}>{'Cintura'}</TableCell>
												<TableCell sx={headerTitlesRopaSX}>{'Cadera'}</TableCell>
											</TableRow>
										</TableHead>

										{activeCmNino ? (
											<TableBody>
												{ropaNinoCmRows.map((row) => (
													<StyledTableRow key={row.talla}>
														<StyledTableCell>{row.talla}</StyledTableCell>
														<StyledTableCell>{row.pecho}</StyledTableCell>
														<StyledTableCell>{row.cintura}</StyledTableCell>
														<StyledTableCell>{row.cadera}</StyledTableCell>
													</StyledTableRow>
												))}
											</TableBody>
										) : (
											<TableBody>
												{ropaNinoInchesRows.map((row) => (
													<StyledTableRow key={row.talla}>
														<StyledTableCell>{row.talla}</StyledTableCell>
														<StyledTableCell>{row.pecho}</StyledTableCell>
														<StyledTableCell>{row.cintura}</StyledTableCell>
														<StyledTableCell>{row.cadera}</StyledTableCell>
													</StyledTableRow>
												))}
											</TableBody>
										)}
									</Table>
								</TableContainer>
								<Stack mt={'27px'} mb={'8px'}>
									<Stack>
										<Typography
											sx={{
												fontSize: 'var(--font-size-sm)',
												fontWeight: 'bold',
												color: '#2C2C2C',
											}}
										>
											{'Pans y leggins'}
										</Typography>
									</Stack>
								</Stack>
								<Divider></Divider>
								<TableContainer>
									<Table sx={{ minWidth: '0px' }}>
										<TableHead>
											<TableRow sx={{ pt: '0px' }}>
												<TableCell sx={headerTitlesRopaSX}>{'Talla'}</TableCell>
												<TableCell sx={headerTitlesRopaSX}>{'Pecho'}</TableCell>
												<TableCell sx={headerTitlesRopaSX}>{'Cintura'}</TableCell>
												<TableCell sx={headerTitlesRopaSX}>{'Cadera'}</TableCell>
											</TableRow>
										</TableHead>
										{activeCmNino ? (
											<TableBody>
												{ropaNinoCmRows.map((row) => (
													<StyledTableRow key={row.talla}>
														<StyledTableCell>{row.talla}</StyledTableCell>
														<StyledTableCell>{row.pecho}</StyledTableCell>
														<StyledTableCell>{row.cintura}</StyledTableCell>
														<StyledTableCell>{row.cadera}</StyledTableCell>
													</StyledTableRow>
												))}
											</TableBody>
										) : (
											<TableBody>
												{ropaNinoInchesRows.map((row) => (
													<StyledTableRow key={row.talla}>
														<StyledTableCell>{row.talla}</StyledTableCell>
														<StyledTableCell>{row.pecho}</StyledTableCell>
														<StyledTableCell>{row.cintura}</StyledTableCell>
														<StyledTableCell>{row.cadera}</StyledTableCell>
													</StyledTableRow>
												))}
											</TableBody>
										)}
									</Table>
								</TableContainer>
							</CustomTabPanel>
							<CustomTabPanel value={valueHombres} index={2}>
								<TableContainer sx={{ maxHeight: '400px' }}>
									<Table sx={{ minWidth: '0px' }} stickyHeader aria-label="sticky table">
										<TableHead>
											<TableRow>
												<TableCell>{'GORRA'}</TableCell>
												<TableCell>{'CENTIMETROS'}</TableCell>
												<TableCell>{'PULGADAS'}</TableCell>
											</TableRow>
										</TableHead>
										<TableBody>
											{gorrasRows.map((row) => (
												<StyledTableRow key={row.gorra}>
													<StyledTableCell>{row.gorra}</StyledTableCell>
													<StyledTableCell>{row.cm}</StyledTableCell>
													<StyledTableCell>{row.pul}</StyledTableCell>
												</StyledTableRow>
											))}
										</TableBody>
									</Table>
								</TableContainer>
							</CustomTabPanel>
						</CustomTabPanel>
					</Box>
				</Stack>
			</Stack>
		</Box>
	);
};
